/** API route map: URLS.Controller.ClientOnboarding */
export const ClientOnboarding = {
      Name: 'ClientOnboarding/',
      GetNewClientsPaginated: 'get-new-clients-paginated',
      GetPendingClientsPaginated: 'get-pending-clients-paginated',
      GetApprovedClientsPaginated: 'get-approved-clients-paginated',
      AddNewOnboardingClient: 'add-new-onboarding-client',
      DeleteOnboardingClient: 'delete-onboarding-client',
      ApproveClient: 'approve-client',
      GetClientStatus: 'get-client-status',
      // Settings
      GetAllOnboardingClientsPaginated: 'get-all-onboarding-clients-paginated',
      GetClientOnboardingSettingsData: 'get-client-onboarding-setting-data',
      OnboardingSettingsPatch: 'onboarding-settings-patch',
      // Profile Summary
      GetClientData: 'get-client-data',
      UpdateClientProfileSummary: 'update-client-profile-summary',
      GetServiceTypesList: 'get-service-types-list',
      GetBusinessEntityTypesList: 'get-business-entity-types-list',
      GetClientCategoriesList: 'get-client-categories-list',
      GetSICCodesList: 'get-sic-codes-list',
      GetNAICSCodesList: 'get-naics-codes-list',
      GetCostCentersList: 'get-cost-centers-list',
      GetSubCostCentersList: 'get-sub-cost-centers-list',
      // Profile Summary - Contacts
      GetClientContacts: 'get-client-contact',
      AddClientContact: 'add-client-contact',
      UpdateClientContact: 'update-client-contact',
      DeleteClientContact: 'delete-client-contact',
      // Notes
      GetClientNotesPaginated: 'get-client-notes-paginated',
      GetClientNotes: 'get-client-notes',
      AddClientNote: 'add-client-note',
      UpdateClientNote: 'update-client-note',
      DeleteClientNote: 'delete-client-note',
      // Account Information
      GetCompanyUsersList: 'get-company-users-list',
      GetCompanyBankAccountsList: 'get-company-bank-accounts-list',
      UpdateClientAccountInformation: 'update-client-account-information',
      // Timesheet
      GetCompanyPayCodesList: 'get-company-pay-codes-list',
      GetTimesheetPayCodes: 'get-timesheet-pay-codes',
      AddTimesheetPayCode: 'add-timesheet-pay-codes',
      DeleteTimesheetPayCode: 'delete-timesheet-pay-codes',
      GetCompanyDeductionCodesList: 'get-company-deduction-codes-list',
      GetTimesheetDeductionCodes: 'get-timesheet-deduction-codes',
      AddTimesheetDeductionCode: 'add-timesheet-deduction-codes',
      DeleteTimesheetDeductionCode: 'delete-timesheet-deduction-codes',
      // Billing
      GetBillingDetails: 'get-billing-details',
      UpdateClientBillingDetails: 'update-client-billing-details',
      GetCompanyABABankRoutingList: 'get-company-aba-bank-routing-list',
      GetCompanyBillingFormatsList: 'get-company-billing-formats-list',
      GetCompanyBillingTemplatesList: 'get-company-billing-templates-list',
      // Benefits
      GetBenefitDetails: 'get-benefit-details',
      UpdateClientBenefitDetails: 'update-client-benefit-details',
      GetCompanyWCPoliciesList: 'get-wc-policies-list',
      GetCompanyWCSubPoliciesList: 'get-wc-sub-policies-list',
      GetCompanyBenefitPlans: 'get-company-benefit-plans',
      GetBenefitRetirementPlans: 'get-benefit-retirement-plans',
      AddBenefitRetirementPlan: 'add-benefit-retirement-plans',
      DeleteBenefitRetirementPlan: 'delete-retirement-plans',
      // Process Control
      GetProcessControlDetails: 'get-process-control-details',
      UpdateClientProcessControlDetails: 'update-process-control-details',
      GetCompanyDeductionCodeArrearsList: 'get-company-deduction-code-arrears-list',
      GetDeductionCodeArrears: 'get-payroll-deduction-code-arrears',
      AddPayrollDeductionCodeArrears: 'add-payroll-deduction-code-arrears',
      DeletePayrollDeductionCodeArrear: 'delete-payroll-deduction-code-arrear',
      GetCompanyEmployeeStatusList: 'get-company-employee-statuses-list',
      GetClientEmployeeStatus: 'get-client-employee-statuses',
      AddClientEmployeeStatus: 'add-client-employee-statuses',
      DeleteClientEmployeeStatus: 'delete-client-employee-status',
      GetCompanyReasonCodeList: 'get-company-reason-codes-list',
      GetClientReasonCodes: 'get-client-reason-codes',
      AddClientReasonCode: 'add-client-reason-codes',
      DeleteClientReasonCode: 'delete-client-reason-code',
      GetAllOnboardingClientsCount: 'get-all-onboarding-clients-count',
      GetClientEmployeeTypes: 'get-client-employee-types',
      GetCompanyEmployeeTypes: 'get-company-employee-types',
      AddClientEmployeeType: 'add-client-employee-type',
      DeleteClientEmployeeType: 'delete-client-employee-type',
};
